import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28" data-testid="about-page">
      <Helmet>
        <title>О пекарне Ишеевские пироги — домашняя выпечка с 1995 года | Ульяновск</title>
        <meta name="description" content="Семейная пекарня из Ишеевки с 1995 года. Традиционные рецепты, свежие продукты, ручная работа. 30+ видов пирогов и пирожков с доставкой по Ульяновску." />
        <link rel="canonical" href="https://pirogi73.ru/o-kompanii/" />
        <meta property="og:title" content="О пекарне Ишеевские пироги | Ульяновск" />
        <meta property="og:description" content="Семейная пекарня из Ишеевки с 1995 года. Традиционные рецепты, свежая выпечка с доставкой по Ульяновску." />
        <meta property="og:url" content="https://pirogi73.ru/o-kompanii/" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "@id": "https://pirogi73.ru/#business",
          "name": "Ишеевские пироги",
          "telephone": "+79378764537",
          "url": "https://pirogi73.ru",
          "foundingDate": "1995",
          "address": { "@type": "PostalAddress", "addressLocality": "Ульяновск", "addressRegion": "Ульяновская область", "addressCountry": "RU" },
          "areaServed": { "@type": "City", "name": "Ульяновск" },
          "openingHoursSpecification": { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"], "opens": "09:00", "closes": "21:00" }
        })}</script>
      </Helmet>

      <div className="label-eyebrow mb-4">О нас</div>
      <h1 className="font-display text-5xl sm:text-6xl text-[#2C2520] leading-tight mb-10">
        Домашняя пекарня
        <br />
        из Ишеевки с 1995 года
      </h1>

      <div className="grid md:grid-cols-2 gap-10 mt-4">
        <div className="space-y-5 text-[#5C4F45] text-lg leading-relaxed">
          <p>
            <span className="font-display text-[#C65D3B] text-2xl">Мы не пекарня при магазине.</span>{" "}
            Мы — семейное производство, которое начиналось с домашней печи и выросло в пекарню с постоянными клиентами по всему Ульяновску. С 1995 года рецепты не менялись: то же тесто, те же начинки, та же ручная работа.
          </p>
          <p>
            Каждое утро замешиваем тесто из свежих ингредиентов. Начинки делаем щедрыми — не экономим на мясе, капусте или рыбе. Пироги готовятся партиями под конкретные заказы, а не лежат в витрине часами.
          </p>
          <p>
            В меню — больше 30 позиций. Сытные пироги: с мясом, капустой, луком и яйцом, картошкой, рыбой. Сладкие: с курагой, яблоками, вишней, малиной, лимоном. Ватрушки, жареные и печёные пирожки, фаст-фуд. Постное меню и свадебные каравай — тоже берём.
          </p>
        </div>

        <div className="relative">
          <div className="aspect-[4/5] rounded-[28px] overflow-hidden bg-[#F2EBE1]">
            <img
              src="/images/webp/22.webp"
              alt="Ишеевские пироги — домашняя выпечка Ульяновск"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-[#2C2520] text-[#F2EBE1] rounded-[20px] px-7 py-5">
            <div className="label-eyebrow text-[#C65D3B] mb-1">с 1995</div>
            <div className="font-display text-2xl leading-tight">
              Готовим
              <br />
              с любовью
            </div>
          </div>
        </div>
      </div>

      <div className="mt-20 grid sm:grid-cols-3 gap-6">
        {[
          { value: "30+", label: "видов выпечки" },
          { value: "7", label: "дней в неделю" },
          { value: "1995", label: "год основания" },
        ].map((s, i) => (
          <div key={i} className="bg-white border border-[#E8E3DA] rounded-[24px] p-8 text-center" data-testid={`stat-${i}`}>
            <div className="font-display text-5xl text-[#C65D3B] mb-2">{s.value}</div>
            <div className="label-eyebrow">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="mt-16 bg-[#F2EBE1] border border-[#E8E3DA] rounded-[28px] p-10">
        <h2 className="font-display text-3xl text-[#2C2520] mb-6">Что мы делаем</h2>
        <div className="grid sm:grid-cols-2 gap-4 text-[#5C4F45]">
          {[
            "Пироги и пирожки печёные — с капустой, мясом, луком и яйцом, картошкой, рыбой",
            "Пирожки жареные — сытные, с хрустящей корочкой",
            "Сладкие пироги и ватрушки — с курагой, яблоками, ягодами, цитрусами",
            "Фаст-фуд — для быстрого перекуса",
            "Свадебные каравай — по заказу, с украшениями",
            "Постное меню — без скоромных ингредиентов",
            "Корпоративные и праздничные заказы любого объёма",
          ].map((item, i) => (
            <div key={i} className="flex gap-3">
              <span className="text-[#C65D3B] font-bold mt-0.5">·</span>
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="text-center mt-16 flex flex-wrap gap-4 justify-center">
        <Link to="/" className="btn-primary" data-testid="about-cta">
          К каталогу →
        </Link>
        <Link to="/pirogi-na-zakaz/" className="inline-flex items-center px-6 py-3 rounded-full border border-[#E8E3DA] text-[#2C2520] hover:border-[#C65D3B] transition-colors">
          Условия заказа
        </Link>
      </div>
    </div>
  );
};

export default About;
